/**
 * Magic module.
 * This module replace mag-app css loader, because we need to load only app styles.
 * Components are not used in this project.
 */

'use strict';

var link = document.createElement('link'),
    height = window.innerHeight || window.screen.height;


switch ( height ) {
    case 480:
    case 576:
    case 720:
    case 1080:
        break;

    default:
        height = 720;
        break;
}


link.rel  = 'stylesheet';
link.href = 'css/app.' + height + '.css' + (DEVELOP ? '?' + Date.now() : '');
document.head.appendChild(link);
